export const STORE_ROOT = "/store";
export const STORE_DRAGGABLE = STORE_ROOT + "/sortDraggable";
export const STORE_RESET_DRAGGABLE = STORE_ROOT + "/resetSortDraggable";